import React from 'react';

const EmploymentHistory = () => {
    return (
        <section className='text-white flex flex-col justify-center items-center py-10'>

            <h2 className='text-3xl font-semibold text-green-800 mb-3 text-center'>EMPLOYMENT HISTORY</h2>

            <article className='flex flex-col gap-3 w-[90%] lg:w-[80%] p-5 bg-color-dark'>

                <div className='flex flex-col gap-1.5'>
                    <span className='flex flex-col gap-3 md:flex-row justify-between text-lg md:text-xl'>
                        <h3 className='text-green-600'>Junior Backend Developer @ TotoCalzados </h3>
                        <p className='text-base'>December 2025 - Present</p>
                    </span>
                    <a className='hover:text-red-600 flex gap-1' href="https://github.com/vicenzomh">
                        <p className='text-red-600'>{'<a>'}</p>
                        <p>View Activity</p>
                        <p className='text-red-600'>{'</a>'}</p>
                    </a>
                </div>

                <div>
                    <ul className='ml-3 flex flex-col gap-2.5 md:text-lg' >
                        <span className='flex justify-start gap-5'>
                            <p className='max-w-11 text-green-600 hidden sm:block'>{'<li>'}</p>
                            <p>Integrated external logistics APIs (UES, Marco Postal, PedidosYa) with webhook receivers for automated order tracking and delivery status updates</p>
                        </span>
                        <span className='flex justify-start gap-5'>
                            <p className='max-w-11 text-green-600 hidden sm:block'>{'<li>'}</p>
                            <p>Built RESTful APIs with .NET Web API following clean architecture, repository pattern, and dependency injection principles</p>
                        </span>
                        <span className='flex justify-start gap-5'>
                            <p className='max-w-11 text-green-600 hidden sm:block'>{'<li>'}</p>
                            <p>Developed real-time logistics dashboards with Angular 19 and TypeScript, featuring live order monitoring with RxJS polling and countdown timers</p>
                        </span>
                        <span className='flex justify-start gap-5'>
                            <p className='max-w-11 text-green-600 hidden sm:block'>{'<li>'}</p>
                            <p>Designed and optimized SQL Server databases, including customer data cleaning systems and audit logging for compliance tracking</p>
                        </span>
                        <span className='flex justify-start gap-5'>
                            <p className='max-w-11 text-green-600 hidden sm:block'>{'<li>'}</p>
                            <p>Collaborated in agile team environment using Git for version control and code reviews</p>
                        </span>
                        <span className='flex justify-start gap-5'>
                            <p className='max-w-11 text-green-600 hidden sm:block'>{'<li>'}</p>
                            <p>Implemented hybrid mobile applications using Ionic Angular for customer loyalty programs</p>
                        </span>
                    </ul>
                </div>

            </article>
        </section>
    );
};
export default EmploymentHistory;